import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import '../ProposalView/CustProposalView.css'
//make sure to comment out MediaQueries until completed.
// import './MediaQueries.css'
import BarChart from '../Charts/BarChart'
import OffsetChart from '../Charts/OffsetChart'
import YearAvgChart from '../Charts/YearAvgChart'
import DoughnutChart from '../Charts/DoughnutChart'

// This is an old one but it might still be used...
// Might be used if there are old proposals...

import CircularProgress from '@material-ui/core/CircularProgress';


import MasterCalc from '../UsageFunctions/MasterCalc'
import PNMCalc from '../UsageFunctions/PNMCalc'
import BlackHillsCalc from '../UsageFunctions/BlackHillsCalc'
import OverRideCalc from '../UsageFunctions/OverRideCalc'
import ColoradoUsage from '../UsageFunctions/ColoradoUsage'
import UtahUsage from '../UsageFunctions/UtahUsage'
import WyomingUsage from '../UsageFunctions/WyomingUsage'
import NevadaUsage from '../UsageFunctions/NevadaUsage'
import VirginiaUsage from '../UsageFunctions/VirginiaUsage'
import OregonUsage from '../UsageFunctions/OregonUsage'
import TexasUsage from '../UsageFunctions/TexasUsage'
import NewMexicoUsage from '../UsageFunctions/NewMexicoUsage'
import NorthCarolinaUsage from '../UsageFunctions/NorthCarolinaUsage'
import SouthCarolinaUsage from '../UsageFunctions/SouthCarolinaUsage'
import FloridaUsage from '../UsageFunctions/FloridaUsage'
import MappedLoans1 from './MappedLoans1'
import MappedLoans2 from './MappedLoans2'

import Title from '../Title/Title'
import jsPDF from 'jspdf'
import moment from 'moment'


const ProposalView = (props) => {

  const [proposal, setProposal] = useState([])
  const [proposals, setProposals] = useState([])
  const [utility, setUtility] = useState('')
  const [monthlyUsage, setMonthlyUsage] = useState('')
  const [customer, setCustomer] = useState([])

  const [janProduction, setJanProduction] = useState('')
  const [febProduction, setFebProduction] = useState('')
  const [marProduction, setMarProduction] = useState('')
  const [aprProduction, setAprProduction] = useState('')
  const [mayProduction, setMayProduction] = useState('')
  const [junProduction, setJunProduction] = useState('')
  const [julyProduction, setJulyProduction] = useState('')
  const [augProduction, setAugProduction] = useState('')
  const [sepProduction, setSepProduction] = useState('')
  const [octProduction, setOctProduction] = useState('')
  const [novProduction, setNovProduction] = useState('')
  const [decProduction, setDecProduction] = useState('')

  const [panelAmount, setPanelAmount] = useState('')
  const [originalPanelAmount, setOriginalPanelAmount] = useState('')
  const [systemSize, setSystemSize] = useState('')
  // const [arrayCount, setArrayCount] = useState('')
  const [systemCost, setSystemCost] = useState('')
  const [totalProduction, setTotalProduction] = useState('')
  const [loanAmount, setLoanAmount] = useState('')
  const [rebate, setRebate] = useState('')
  const [partialPanels, setPartialPanels] = useState('')
  const [stateTax, setStateTax] = useState(0)
  const [pRatio] = useState('')
  const [mod, setMod] = useState('')
  const [modules, setModules] = useState([])
  const [inverters, setInverters] = useState([])
  const [uType, setUType] = useState('')
  const [design, setDesign] = useState('')
  const [calcUtility, setCalcUtility] = useState('')
  const [annualUsage, setAnnualUsage] = useState('')
  const [squareFootage, setSquareFootage] = useState('')
  const [viewEquipment, setViewEquipment] = useState(false)
  const [viewAdders, setViewAdders] = useState(false)
  const [viewProposals, setViewProposals] = useState(false)
  const [rebateSF, setRebateSF] = useState('')
  const [timeStamp, setTimeStamp] = useState('')

  //adders
  const [adderTotal, setAdderTotal] = useState('')
  const [treeRemoval, setTreeRemoval] = useState(0)
  const [treeRemovalAmount, setTreeRemovalAmount] = useState('')
  const [reRoof, setReRoof] = useState(0)
  const [reRoofAmount, setReRoofAmount] = useState('')
  const [smartHome, setSmartHome] = useState(0)
  const [smartHomeAmount, setSmartHomeAmount] = useState('')
  const [hvac, setHvac] = useState(0)
  const [hvacAmount, setHvacAmount] = useState('')
  const [led, setLed] = useState(0)
  const [ledAmount, setLedAmount] = useState('')
  const [turf, setTurf] = useState(0)
  const [turfAmount, setTurfAmount] = useState('')
  const [windows, setWindows] = useState(0)
  const [windowsAmount, setWindowsAmount] = useState('')
  const [water, setWater] = useState(0)
  const [waterAmount, setWaterAmount] = useState('')
  const [travel, setTravel] = useState(0)
  const [travelAmount, setTravelAmount] = useState('')
  const [ballast, setBallast] = useState(0)
  const [ballastAmount, setBallastAmount] = useState(.20)
  const [ballastPanels, setBallastPanels] = useState('')
  const [ballastTotal, setBallastTotal] = useState('')
  const [pSolar, setPSolar] = useState(0)
  const [pSolarAmount, setPSolarAmount] = useState(.15)
  const [groundMount, setGroundMount] = useState(0)
  const [groundMountAmount, setGroundMountAmount] = useState(1.30)
  const [groundMountPanels, setGroundMountPanels] = useState('')
  const [groundMountTotal, setGroundMountTotal] = useState('')
  const [msp, setMsp] = useState(0)
  const [mspAmount, setMspAmount] = useState(1500)
  const [critterGuard, setCritterGuard] = useState(0)
  const [critterGuardAmount, setCritterGuardAmount] = useState(0.10)
  const [battery3, setBattery3] = useState(0)
  const [battery3Amount] = useState(9204)
  const [battery10, setBattery10] = useState(0)
  const [battery10Amount, setBattery10Amount] = useState(16000)
  const [ppw, setPpw] = useState('')
  const [basePpw, setBasePpw] = useState('')
  const [commission, setCommission] = useState('')
  const [overRide] = useState(false)
  const [ionRebate, setIonRebate] = useState('')
  const [ionRebate2, setIonRebate2] = useState('')
  const [slcAdder, setSlcAdder] = useState('')
  const [slcAdderAmount, setSlcAdderAmount] = useState(600)
  const [nest, setNest] = useState('')
  const [nestAmount, setNestAmount] = useState(2076)
  const [nestMax, setNestMax] = useState(.05)
  const [adderAmount, setAdderAmount] = useState(600)
  const [adderAmount2, setAdderAmount2] = useState(1200)
  const [preferredUtility, setPreferredUtility] = useState(0)
  const [preferredUtilityAmount, setPreferredUtilityAmount] = useState(.40)
  const [sameDay, setSameDay] = useState(0)
  const [sameDayAmount, setSameDayAmount] = useState(1000)
  const [referral, setReferral] = useState(0)
  const [referralAmount, setReferralAmount] = useState(1500)
  const [nestAdder, setNestAdder] = useState(0)
  const [nestAdderAmount, setNestAdderAmount] = useState(100)
  const [sustainable, setSustainable] = useState(0)
  const [sustainableAmount, setSustainableAmount] = useState(200)

  const [calculation, setCalculation] = useState('')

  // const [loanProducts, setLoanProducts] = useState([])

  // const [setterAmount] = useState(.20)

  const [loanA, setLoanA] = useState('')
  const [loanB, setLoanB] = useState([])
  const [utilityId, setUtilityId] = useState('')
  const [inverterId, setInverterId] = useState('')
  const [hasRebate, setHasRebate] = useState('')
  const [salesTeam, setSalesTeam] = useState('')



  const getProposal = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_proposal', prop_id: props.match.params.prop_id }).then((res) => {
      // console.log(res.data)
      const { jan, feb, mar, apr, may, june, july, aug, sept, oct, nov, december, modCount, ogModCount, systemSize, ballast, ballastModules, groundMount, msp, pSolar, travel, critterGuard, id1, loan1, term1, int1, pre1, post1, interest1, id2, loan2, term2, int2, pre2, post2, interest2, ionRebate, ionRebate2, slcAdder, arrayCount, hasNest, propDesign, travelAmount, treeTrim, treeTrimAmount, reroof, reroofAmount, itc1, itc2, utility, rebateOverride, modId, utilityPpw, ppw, module, modModel, modSize, modPtcRating, utilityId, invId, hasRebate, battery3, battery10, sameDay, preferredUtility, referral, hasNestAdder, rebatePanels, groundMountModules, sustainable, smartHome, smartHomeAmount, hvac, hvacAmount, led, ledAmount, turf, turfAmount, windows, windowsAmount, water, waterAmount } = res.data.data
      let rOverride = hasRebate
      if (+rebateOverride > 1) {
        rOverride = rebateOverride
      }
      return [setLoanA([+id1, loan1.toUpperCase(), +term1, +int1, +pre1, +post1, +interest1, +itc1]), setMod([modId, module, modModel, modSize, modPtcRating]), setNest(+hasNest), setLoanB([+id2, loan2.toUpperCase(), +term2, +int2, +pre2, +post2, +interest2, +itc2
      ]), setProposal(res.data.data), setPpw(+ppw), setBasePpw(+utilityPpw), setJanProduction(+jan), setFebProduction(+feb), setMarProduction(+mar), setAprProduction(+apr), setMayProduction(+may), setJunProduction(+june), setJulyProduction(+july), setAugProduction(+aug), setSepProduction(+sept), setOctProduction(+oct), setNovProduction(+nov), setDecProduction(+december), setPanelAmount(+modCount), setOriginalPanelAmount(+ogModCount), setBallast(+ballast), setGroundMount(+groundMount), setMsp(+msp), setPSolar(+pSolar), setTravel(+travel), setTravelAmount(+travelAmount), setTreeRemoval(+treeTrim), setTreeRemovalAmount(+treeTrimAmount), setReRoof(+reroof), setReRoofAmount(+reroofAmount), setCritterGuard(+critterGuard), setBattery3(+battery3), setBattery10(+battery10), setIonRebate(+ionRebate), setIonRebate2(+ionRebate2), setSlcAdder(+slcAdder), setDesign(propDesign), setCalcUtility(utility), setBallastPanels(+ballastModules), setGroundMountPanels(+groundMountModules), setUtilityId(utilityId), setInverterId(invId), setHasRebate(rOverride), setSameDay(+sameDay), setPreferredUtility(+preferredUtility), setReferral(+referral), setNestAdder(+hasNestAdder), setCalculation(res.data.calc), setPartialPanels(+rebatePanels), setSustainable(+sustainable), , setSmartHome(+smartHome), setSmartHomeAmount(+smartHomeAmount), setHvac(+hvac), setHvacAmount(+hvacAmount), setLed(+led), setLedAmount(+ledAmount), setTurf(+turf), setTurfAmount(+turfAmount), setWindows(+windows), setWindowsAmount(+windowsAmount), setWater(+water), setWaterAmount(+waterAmount)]
    })
  }
  if (originalPanelAmount === 0) {
    setOriginalPanelAmount(panelAmount)
  }

  useEffect(() => {
    if (+proposal.ballastAmount > 0) {
      setBallastAmount(+proposal.ballastAmount)
    }
    if (+proposal.critterGuardAmount > 0) {
      setCritterGuardAmount(+proposal.critterGuardAmount)
    }
    if (+proposal.mspAmount > 0) {
      setMspAmount(+proposal.mspAmount)
    }
    if (+proposal.pSolarAmount > 0) {
      setPSolarAmount(+proposal.pSolarAmount)
    }
    if (+proposal.battery10Amount > 0) {
      setBattery10Amount(+proposal.battery10Amount)
    }
    if (+proposal.groundMountAmount > 0) {
      setGroundMountAmount(+proposal.groundMountAmount)
    }
  }, [proposal])

  // console.log(calculation)


  const getCustomer = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_info', project_id: proposal.projectId }).then((res) => {
      // console.log(res.data)
      return [setCustomer(res.data.data), setUtility(res.data.data.utility), setMonthlyUsage(res.data.usage), setUType(res.data.data.usageType), setSquareFootage(res.data.data.sqFootage), setSalesTeam(res.data.data.salesTeam)]
    })
  }
  let multiply = (num1, num2) => {
    return num1 * num2
  }

  // console.log(proposals)

  useEffect(() => {
    if (design) {
      setTimeStamp(moment().format('MM/DD/YY, h:mm a'))
    }
  }, [design])


  useEffect(() => {
    setSystemCost(Math.round(+proposal.loanAmount + +proposal.rebate + +proposal.downPayment))
  }, [proposal])

  // console.log(proposal)
  useEffect(() => {
    getProposal()
  }, [])


  useEffect(() => {
    if (proposal?.projectId) {
      getCustomer()
    }
  }, [proposal])

  // console.log(customer)

  useEffect(() => {
    setSystemSize(panelAmount * mod[3])
  }, [panelAmount, mod])

  useEffect(() => {
    if (uType === 'Square Footage') {
      switch (customer.territory) {
        case 'Albuquerque':
          //setAnnualUsage(9503)
          break;
        case 'Colorado Springs':
          //setAnnualUsage(9955)
          break;
        case 'Las Vegas':
          if (squareFootage >= 4000) {
           // return setAnnualUsage(Math.round(2392.4 * Math.pow(+squareFootage, .25)))
          } else if (squareFootage < 4000 && squareFootage > 1000) {
           // return setAnnualUsage(Math.round(4.286 * +squareFootage + 1882))
          } else if (squareFootage <= 1000) {
           // return setAnnualUsage(Math.round(195.05 * Math.pow(+squareFootage, .5)))
          }
          // setAnnualUsage(12771)
          break;
        case 'Buda':
          //setAnnualUsage(12479)
          break;
        case 'Denver':
          //setAnnualUsage(10413)
          break;
        case 'Dallas':
          //setAnnualUsage(12236)
          break;
        case 'Utah':
          //setAnnualUsage(10639)
          break;
        case 'Oregon':
          //setAnnualUsage(9687)
          break;
        case 'North Carolina':
          //setAnnualUsage(13100)
          break;
        case 'South Carolina':
          //setAnnualUsage(13100)
          break;
        case 'Richmond':
          //setAnnualUsage(16126)
          break;
        case 'Virginia Beach':
          //setAnnualUsage(15052)
          break;
        default:
          //setAnnualUsage(12475)
      }
      // if (squareFootage >= 4000) {
      //   return setAnnualUsage(Math.round(2392.4 * Math.pow(+squareFootage, .25)))
      // } else if (squareFootage < 4000 && squareFootage > 1000) {
      //   return setAnnualUsage(Math.round(4.286 * +squareFootage + 1882))
      // } else if (squareFootage <= 1000) {
      //   return setAnnualUsage(Math.round(195.05 * Math.pow(+squareFootage, .5)))
      // }
    }
  }, [customer, uType, squareFootage])

  useEffect(() => {
    if (uType === 'Annual' || uType === 'Annual - Square Footage') {
      setAnnualUsage(customer.usage)
    }
  }, [customer, uType])



  const { january, february, march, april, may, june, july, august, september, october, november, december } = monthlyUsage
  const { modSize, rebateType, invRating, modPtcRating, rebatePerWatt, rebateFixed, modId, modModel, rebateMax, module, invType, invModel, modCount, propRatio, downPayment, utilityLocation, rateOverRide, rateAmount, arrayCount, maxModCount, costOverRide, ballastModules, groundMountModules } = proposal

  const { tierType, surcharge, tax, tier1, tier2, tier3, tier4, sTier1, sTier2, sTier3, sTier4, wTier1, wTier2, wTier3, wTier4, tierAmount, sTierAmount, wTierAmount, tier1Amount, tier2Amount, tier3Amount, tier4Amount, sTier1Amount, sTier2Amount, sTier3Amount, sTier4Amount, wTier1Amount, wTier2Amount, wTier3Amount, wTier4Amount } = calculation

  let calcs = [tierType, +surcharge, +tax, +tier1, +tier2, +tier3, +tier4, +sTier1, +sTier2, +sTier3, +sTier4, +wTier1, +wTier2, +wTier3, +wTier4, +tierAmount, +sTierAmount, +wTierAmount, +tier1Amount, +tier2Amount, +tier3Amount, +tier4Amount, +sTier1Amount, +sTier2Amount, +sTier3Amount, +sTier4Amount, +wTier1Amount, +wTier2Amount, +wTier3Amount, +wTier4Amount]

  // console.log(calcs)

  // useEffect(() => {
  //   if (nest === 2) {
  //     return setNestMax(.05)
  //   }
  //   if (nest === 1) {
  //     return setNestMax(.1)
  //   }
  // }, [nest])

  useEffect(() => {
    if (ballast === 1) {
      return setBallastPanels(+ballastModules)
    } setBallastPanels(+panelAmount)
  }, [proposal, ballastPanels, ballast])

  useEffect(() => {
    if (ballastModules > 0) {
      return setBallastTotal((+ballastPanels * +mod[3]) * +ballastAmount)
    } setBallastTotal(+systemSize * +ballastAmount)
  }, [proposal, ballast, ballastPanels])

  useEffect(() => {
    if (groundMount === 1) {
      return setGroundMountPanels(+groundMountModules)
    } setGroundMountPanels(+panelAmount)
  }, [proposal, groundMountPanels, groundMount])

  useEffect(() => {
    if (groundMountModules > 0) {
      return setGroundMountTotal((+groundMountPanels * +mod[3]) * +groundMountAmount)
    } setGroundMountTotal(+systemSize * +groundMountAmount)
  }, [proposal, groundMount, groundMountPanels])


  // console.log(groundMount, groundMountPanels, groundMountTotal)

  //loan[0] = loanId
  //loan[1] = loanName
  //loan[2] = term
  //loan[3] = interest
  //loan[4] = prePayment
  //loan[5] = postPayment
  //loan[6] = intOnlyPayment

  //mod[0] = modId
  //mod[1] = module
  //mod[2] = mod_model
  //mod[3] = modSize
  //mod[4] = modPtcRating

  // console.log(module)

  let usage = [+january, +february, +march, +april, +may, +june, +july, +august, +september, +october, +november, +december]
  let usageChart = [+january, +february, +march, +april, +may, +june, +july, +august, +september, +october, +november, +december]
  let currentUsage = [+january, +february, +march, +april, +may, +june, +july, +august, +september, +october, +november, +december]
  let production = [+janProduction, +febProduction, +marProduction, +aprProduction, +mayProduction, +junProduction, +julyProduction, +augProduction, +sepProduction, +octProduction, +novProduction, +decProduction]
  let productionChart = [+janProduction, +febProduction, +marProduction, +aprProduction, +mayProduction, +junProduction, +julyProduction, +augProduction, +sepProduction, +octProduction, +novProduction, +decProduction]

  // console.log(currentUsage)


  let monthNest = nestAmount / 12

  if (nest > 0) {
    production = production.map(x => x + monthNest)
    usageChart = usageChart.map(x => x - monthNest)
  }

  // console.log(production)

  let jan = +janProduction / totalProduction
  let feb = +febProduction / totalProduction
  let mar = +marProduction / totalProduction
  let apr = +aprProduction / totalProduction
  let mayP = +mayProduction / totalProduction
  let jun = +junProduction / totalProduction
  let julyP = +julyProduction / totalProduction
  let aug = +augProduction / totalProduction
  let sep = +sepProduction / totalProduction
  let oct = +octProduction / totalProduction
  let nov = +novProduction / totalProduction
  let dec = +decProduction / totalProduction

  if (nest > 0) {
    jan = +janProduction / (totalProduction - nestAmount)
    feb = +febProduction / (totalProduction - nestAmount)
    mar = +marProduction / (totalProduction - nestAmount)
    apr = +aprProduction / (totalProduction - nestAmount)
    mayP = +mayProduction / (totalProduction - nestAmount)
    jun = +junProduction / (totalProduction - nestAmount)
    julyP = +julyProduction / (totalProduction - nestAmount)
    aug = +augProduction / (totalProduction - nestAmount)
    sep = +sepProduction / (totalProduction - nestAmount)
    oct = +octProduction / (totalProduction - nestAmount)
    nov = +novProduction / (totalProduction - nestAmount)
    dec = +decProduction / (totalProduction - nestAmount)
  }

  let propRatios = [jan, feb, mar, apr, mayP, jun, julyP, aug, sep, oct, nov, dec]


  useEffect(() => {
    setJanProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * jan))
  }, [systemSize])

  useEffect(() => {
    setFebProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * feb))
  }, [systemSize])

  useEffect(() => {
    setMarProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * mar))
  }, [systemSize])

  useEffect(() => {
    setAprProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * apr))
  }, [systemSize])

  useEffect(() => {
    setMayProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * mayP))
  }, [systemSize])

  useEffect(() => {
    setJunProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * jun))
  }, [systemSize])

  useEffect(() => {
    setJulyProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * julyP))
  }, [systemSize])

  useEffect(() => {
    setAugProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * aug))
  }, [systemSize])

  useEffect(() => {
    setSepProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * sep))
  }, [systemSize])

  useEffect(() => {
    setOctProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * oct))
  }, [systemSize])

  useEffect(() => {
    setNovProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * nov))
  }, [systemSize])

  useEffect(() => {
    setDecProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * dec))
  }, [systemSize])


  const total = (arr) => arr.reduce((a, b) => a + b)

  useEffect(() => {
    if (utilityLocation === 'Utah') {
      return setStateTax(800)
    }
  }, [proposal])

  // console.log(proposal.projectId)



  useEffect(() => {
    if (utilityLocation === 'New Mexico') {
      let tax = (systemCost - homeEnergyTotal) * .10
      console.log(tax)
      if (tax >= 6000) {
        return setStateTax(6000)
      } setStateTax(Math.round(tax))
    }
    if (utilityLocation === 'South Carolina') {
      let tax = (systemCost - homeEnergyTotal) * .25
      console.log(tax)
      if (tax >= 8750) {
        return setStateTax(8750)
      } setStateTax(Math.round(tax))
    }
  }, [props.loan, panelAmount, systemCost, systemSize])

  useEffect(() => {
    if ((billCalc[2] * nestMax) < 2076) {
      setNestAmount(billCalc[2] * nestMax)
    }
  }, [production, nest])

  // console.log(nestMax, nest, nestAmount)


  useEffect(() => {
    setTotalProduction(total(production))
  }, [production])

  const { name, street, state, city, zip, phone } = customer

  // useEffect(() => {
  //   if (systemSize < 10000) {
  //     setGroundMountAmount(.85)
  //   }
  //   if (systemSize >= 10000) {
  //     setGroundMountAmount(.80)
  //   }
  // }, [panelAmount, systemSize])

  // console.log(groundMountAmount)


  // console.log(utilityLocation, state)
  let newUsage;

  switch (utilityLocation) {
    case 'Colorado':
      newUsage = ColoradoUsage(usage, annualUsage)
      break;
    case 'Utah':
    case 'Idaho':
      newUsage = UtahUsage(usage, annualUsage)
      break;
    case 'Wyoming':
      newUsage = WyomingUsage(usage, annualUsage)
      break;
    case 'Nevada':
      newUsage = NevadaUsage(usage, annualUsage)
      break;
    case 'Virginia':
      newUsage = VirginiaUsage(usage, annualUsage)
      break;
    case 'Oregon':
      newUsage = OregonUsage(usage, annualUsage)
      break;
    case 'Texas':
      newUsage = TexasUsage(usage, annualUsage)
      break;
    case 'New Mexico':
      newUsage = NewMexicoUsage(usage, annualUsage)
      break;
    case 'North Carolina':
      newUsage = NorthCarolinaUsage(usage, annualUsage)
      break;
    case 'South Carolina':
      newUsage = SouthCarolinaUsage(usage, annualUsage)
      break;
    case 'Florida':
      newUsage = FloridaUsage(usage, annualUsage)
      break;
    default:
      newUsage = monthlyUsage
  }

  // console.log(annualUsage)

  let totalUsage;
  if (newUsage) {
    usage = newUsage
    totalUsage = total(newUsage)
  }

  let newBill = []
  for (let i = 0; i <= production.length - 1; i++) {
    newBill.push(usage[i] - production[i])
  }

  // console.log(newUsage, usage)

  let custUtility = calcUtility
  let billCalc;
  let postBill;

  if (rateOverRide === '0') {
    switch (custUtility) {
      case 'PNM - Public Service Company of New Mexico':
      case 'Continental Divide Electric':
      case 'CNM':
        billCalc = PNMCalc(usage)
        postBill = PNMCalc(newBill)
        break;
      case 'Black Hills Electric':
        billCalc = BlackHillsCalc(usage)
        postBill = BlackHillsCalc(newBill)
        break;
      default:
        billCalc = MasterCalc(usage, calcs)
        postBill = MasterCalc(newBill, calcs)
    }
  } else {
    billCalc = OverRideCalc(usage, rateAmount)
    postBill = OverRideCalc(newBill, rateAmount)
  }


  useEffect(() => {
    let pu = 0
    let sd = 0
    let ref = 0
    if (sameDay === 1) {
      sd = +sameDayAmount
    }
    if (preferredUtility === 1) {
      pu = +preferredUtilityAmount
    }
    if (referral === 1) {
      ref = +referralAmount
    }
    if (custUtility === 'Austin Energy' || custUtility === 'City of Fort Collins Utilities') {
      return setLoanAmount(Math.round(systemCost - downPayment - sd - ref - (systemSize * pu)))

    }
    if (custUtility === 'Salem Electric') {
      if (hasRebate > 1) {
        return setLoanAmount(Math.round(systemCost - rebate - downPayment - sd - ref - (systemSize * pu)))
      }
      return setLoanAmount(Math.round(systemCost - downPayment - sd - ref - (systemSize * pu)))
    }
    setLoanAmount(Math.round(systemCost - rebate - downPayment - sd - ref - (systemSize * pu)))
  }, [panelAmount, systemCost, rebate, custUtility])

  // console.log(loanAmount, systemCost, rebate)
  // useEffect(() => {
  //   if (salesTeam === 'Austin Sales Team 2') {
  //     if (utility === 'Austin Energy') {
  //       return setHasRebate('1')
  //     } if (utility === 'CPS - City Public Service') {
  //       return setHasRebate('1')
  //     }
  //     return setHasRebate('0')
  //   }
  // }, [systemSize, proposal, hasRebate, salesTeam, rebate])



  // console.log(salesTeam, rebate)

  useEffect(() => {
    if (partialPanels < panelAmount) {
      return setPartialPanels(+partialPanels)
    } setPartialPanels(+panelAmount)
  }, [partialPanels, panelAmount])

  // console.log(partialPanels, proposal.rebatePanels)

  useEffect(() => {
    if (proposal.rebateOverride === '1' || +proposal.rebate < 1) {
      return setRebate(proposal.rebate)
    }
    if (custUtility === 'Austin Energy' && proposal.rebate > 0) {
      return setRebate(proposal.rebate)
    }
    if (custUtility === 'CPS - City Public Service' && proposal.rebate > 0) {
      return setRebate(proposal.rebate)
    }
    let oregonDc = 0
    if (+hasRebate > 0 && custUtility !== 'Austin Energy') {
      let oregonMax = 5000
      let ac = 0
      let rMax = +rebateMax
      let perWatt = +rebatePerWatt
      if (+hasRebate > 1) {
        rMax = oregonMax
      }
      if (+hasRebate === 2) {
        perWatt = 1.80
      }
      if (+hasRebate === 3) {
        perWatt = .20 + +rebatePerWatt
        rMax = (+oregonMax + +rebateMax)
      }
      if (+hasRebate === 4) {
        perWatt = .50
      }
      if (+hasRebate === 5) {
        perWatt = 1.80 + +rebatePerWatt
        rMax = (+oregonMax + +rebateMax)
      }
      if (rebateType === 'Per Watt A/C') {
        ac = partialPanels * mod[4] * invRating * perWatt
      }
      let dc = 0
      if (rebateType === 'Per Watt D/C') {
        dc = partialPanels * mod[3] * perWatt
      }
      let fixed = 0
      if (rebateType === 'Fixed') {
        fixed = rebateFixed
      }
      let totalRebate = (ac + dc + fixed)
      if (rebateMax) {
        if (totalRebate >= +rMax) {
          return setRebate(+rMax)
        } return setRebate(+totalRebate)
      } return setRebate(+totalRebate)
    } return setRebate(0)
  }, [systemSize, proposal, hasRebate, salesTeam, rebate, utility])

  let oregonLabel = 'Energy Trust Incentive'
  if (+hasRebate === 2 || +hasRebate === 4) {
    oregonLabel = 'ODOE Rebate'
  }
  if (+hasRebate === 3 || +hasRebate === 5) {
    oregonLabel = 'ETO + ODOE Rebate'
  }


  useEffect(() => {
    if (custUtility === 'Austin Energy') {
      if (panelAmount * mod[4] * invRating < 3000 && (total(production) / total(usage)) < .75) {
        return setRebate(0)
      }
    }
  }, [systemSize, production, panelAmount])



  useEffect(() => {
    let tt = 0
    if (treeRemoval === 1) {
      tt = +treeRemovalAmount
    }
    let rr = 0
    if (reRoof === 1) {
      rr = +reRoofAmount
    }
    let sh = 0
    if (smartHome === 1) {
      sh = +smartHomeAmount
    }
    let hv = 0
    if (hvac === 1) {
      hv = +hvacAmount
    }
    let ld = 0
    if (led === 1) {
      ld = +ledAmount
    }
    let trf = 0
    if (turf === 1) {
      trf = +turfAmount
    }
    let wdw = 0
    if (windows === 1) {
      wdw = +windowsAmount
    }
    let wtr = 0
    if (water === 1) {
      wtr = +waterAmount
    }
    return setAdderTotal((tt + rr + sh + hv + ld + trf + wdw + wtr))
  }, [treeRemoval, treeRemovalAmount, reRoof, reRoofAmount, smartHome, smartHomeAmount, hvac, hvacAmount, led, ledAmount, turf, turfAmount, windows, windowsAmount, water, waterAmount])

  let homeEnergyTotal = smartHomeAmount + hvacAmount + ledAmount + turfAmount + windowsAmount + waterAmount



  useEffect(() => {
    if (utilityLocation === 'Virginia' || utilityLocation === 'North Carolina' || utilityLocation === 'South Carolina') {
      setAdderAmount(0)
    }

    let perWatt = +ppw
    let bal = 0;
    let setter = 0
    // if (props.setter) {
    //   setter = +setterAmount
    // }
    if (ballast === 1) {
      bal = +ballastTotal;
    }
    let gm = 0;
    if (groundMount === 1) {
      gm = +groundMountTotal;
    }
    let ps = 0;
    if (pSolar === 1) {
      ps = +pSolarAmount;
    }
    let tr = 0
    if (travel === 1) {
      tr = +travelAmount
    }
    let adder = 0;
    if (ionRebate === 1 || ionRebate === 2) {
      adder = +adderAmount
    }
    let adder2 = 0
    if (ionRebate2 === 1) {
      adder2 = +adderAmount2
    }
    let slc = 0
    if (slcAdder === 1) {
      slc = +slcAdderAmount
    }
    let ms = 0;
    if (msp === 1) {
      ms = +mspAmount;
    }
    let cg = 0;
    if (critterGuard === 1) {
      cg = +critterGuardAmount;
    }
    let b3 = 0;
    if (battery3 === 1) {
      b3 = +battery3Amount;
    }
    let b10 = 0;
    if (battery10 > 0) {
      b10 = (+battery10Amount * +battery10);
    }
    let sd = 0;
    if (sameDay === 1) {
      sd = +sameDayAmount;
    }
    let pu = 0;
    if (preferredUtility === 1) {
      pu = +preferredUtilityAmount;
    }
    let ref = 0;
    if (referral === 1) {
      ref = +referralAmount;
    }
    let sus = 0;
    if (sustainable === 1) {
      sus = +sustainableAmount;
    }
    let na = 0;
    if (nestAdder === 1 && nest < 3) {
      na = +nestAdderAmount;
    }
    if (nestAdder === 1 && nest === 3) {
      na = +nestAdderAmount * 2;
    }
    if (costOverRide === '1') {
      return setSystemCost(+proposal.loanAmount + +proposal.rebate + +proposal.downPayment + ref + sd + (pu * systemSize))
    }
    if ((+perWatt * systemSize) < 12500) {
      return setSystemCost(12500 + systemSize * (ps + tr + cg + pu) + adder + adder2 + slc + ms + sus + gm + bal + b3 + b10 + sd + ref + na + adderTotal)
    }
    // if (custUtility === 'CPS - City Public Service') {
    //   return setSystemCost((+perWatt + ps + cg + pu) * systemSize + ms + gm + bal + b3 + b10 + sd + ref + na + adderTotal)
    // } 
    if (utilityLocation === 'Texas' && custUtility !== 'Austin Energy') {
      return setSystemCost((+perWatt + ps + cg + tr + pu) * systemSize + adder + adder2 + slc + ms + sus + gm + bal + b3 + b10 + sd + ref + na + adderTotal)
    } if (utilityLocation === 'Texas' && custUtility !== 'CPS - City Public Service') {
      return setSystemCost((+perWatt + ps + cg + tr + pu) * systemSize + adder + adder2 + slc + ms + sus + gm + bal + b3 + b10 + sd + ref + na + adderTotal)
    }
    return setSystemCost((+perWatt + setter + ps + tr + cg + pu) * systemSize + adder + adder2 + slc + ms + sus + gm + bal + b3 + b10 + sd + ref + na + adderTotal)
  }, [ballast, ballastTotal, ionRebate, ionRebate2, groundMount, pSolar, msp, critterGuard, overRide, systemSize, basePpw, panelAmount, travel, travelAmount, adderTotal, custUtility, costOverRide, salesTeam, ppw, loanA, battery3, battery10, sameDay, preferredUtility, referral, nestAdder, nest, custUtility, slcAdder, groundMountPanels, groundMountTotal, sustainable])



  // console.log(rebate)

  // console.log(utilityLocation, systemCost, ppw, custUtility)

  // console.log(loanAmount, costOverRide)

  // billCalc[0] = array of customer's bill amounts for each month
  // billCalc[1] = averageBill
  // billCalc[2] = annualUsage
  // billCalc[3] = annualBill
  // billCalc[4] = averageUsage

  //loan[0] = loanId
  //loan[1] = loanName
  //loan[2] = term
  //loan[3] = interest
  //loan[4] = prePayment
  //loan[5] = postPayment
  //loan[6] = intOnlyPayment

  const twentyFiveYear = (total, years, ratePercent) => {
    let interestRate = ((ratePercent / 100) + 1)
    return (total * Math.pow(interestRate, years)).toFixed(2);
  }


  let loan1Bills = []

  if (loanA && loanA[6]) {
    loan1Bills = new Array(+loanA[2] - 1).fill(+(loanA[4] * loanAmount).toFixed(2))
    loan1Bills.unshift(+(loanA[6] * loanAmount).toFixed(2));
  } else if (loanA && !loanA[6]) {
    loan1Bills = new Array(+loanA[2]).fill(+(loanA[4] * loanAmount).toFixed(2));
  }

  // console.log(loan1Bills)

  let loan2Bills = []

  if (loanB && loanB[6]) {
    loan2Bills = new Array(+loanB[2] - 1).fill(+(loanB[4] * loanAmount).toFixed(2))
    loan2Bills.unshift(+(loanB[6] * loanAmount).toFixed(2));
  } else if (loanB && !loanB[6]) {
    loan2Bills = new Array(loanB[2]).fill(+(loanB[4] * loanAmount).toFixed(2));
  }

  let increase = 4
  if (custUtility === 'Austin Energy') {
    increase = 2
  } else {
    increase = 4
  }

  // console.log(custUtility, utilityLocation)
  let years = []
  if (janProduction) {
    for (let i = 0; i <= 24; i++) {
      years.push(+twentyFiveYear(+billCalc[1], i, increase))
    }
  } else {
    years.push(0)
  }

  let postYears = []

  if (postBill) {
    for (let i = 0; i <= 24; i++) {
      postYears.push(+twentyFiveYear(+postBill[1], i, increase))
    }
  } else {
    postYears.push(0)
  }

  let postYears1 = []

  if (postBill) {
    for (let i = 0; i <= 24; i++) {
      postYears1.push(+twentyFiveYear(35, i, increase))
    }

  } else {
    postYears1.push(0)
  }

  // console.log(postBill, postYears)

  let saving = []
  let savings = []
  let years1 = []
  let save = []

  const savingsCalc = (arr) => {
    postYears.slice(0, arr.length)
    years1 = postYears.slice(- (25 - arr.length), 25)
    for (let i = 0; i < arr.length; i++) {
      saving.push(postYears[i] + arr[i])
    }
    save = saving.concat(years1)
    // console.log(save)
    for (let i = 0; i <= years.length - 1; i++) {
      savings.push(years[i] - save[i])
    }
    savings = savings.map(x => x * 12)
    // console.log(savings)
    return total(savings)
  }

  const loan1Savings = savingsCalc(loan1Bills)


  let saving1 = []
  let savings1 = []
  let years11 = []
  let save1 = []

  const savingsCalc1 = (arr) => {
    postYears.slice(0, arr.length)
    years11 = postYears.slice(- (25 - arr.length), 25)
    for (let i = 0; i < arr.length; i++) {
      saving1.push(postYears[i] + arr[i])
    }
    save1 = saving1.concat(years11)
    // console.log(save1)
    for (let i = 0; i <= years.length - 1; i++) {
      savings1.push(years[i] - save1[i])
    }
    savings1 = savings1.map(x => x * 12)
    // console.log(savings1)
    return total(savings1)
  }

  const loan2Savings = savingsCalc1(loan2Bills)

  // console.log('postYears', postYears, 'postBill', postBill, 'years', years, newBill, usage)


  const offset = () => {
    if (Math.round(100 - (totalProduction / +totalUsage * 100)) <= 0) {
      return <span className={uType === 'Square Footage' ? ' noDisplayc' : ''}>0%</span>
    } return <span className={uType === 'Square Footage' ? ' noDisplayc' : ''}>{Math.round(100 - (totalProduction / +totalUsage * 100))}%</span>
  }


  //loan[0] = loanId
  //loan[1] = loanName
  //loan[2] = term
  //loan[3] = interest
  //loan[4] = prePayment
  //loan[5] = postPayment
  //loan[6] = intOnlyPayment


  //ENVIRONMENTAL IMPACT CALCULATIONS BELOW

  const gallons = () => {
    let one = (totalProduction) * (-0.000689551)
    if (nest > 0) {
      one = (totalProduction - nestAmount) * (-0.000689551)
    }
    let two = -one
    let three = two * 1.10231
    let four = three * 67629
    return <span>{Math.round(four / 25).toLocaleString(undefined)}</span>
  }


  const homes = () => {
    let one = (totalProduction) * (25)
    if (nest > 0) {
      one = (totalProduction - nestAmount) * (25)
    }
    return <span>{Math.round(one / 10000).toLocaleString(undefined)}</span>
  }

  const garbage = () => {
    let one = (totalProduction) * (-0.000689551)
    if (nest > 0) {
      one = (totalProduction - nestAmount) * (-0.000689551)
    }
    let two = -one
    let three = two * 1.10231
    let four = three * 36
    return <span>{Math.round(four).toLocaleString(undefined)}</span>
  }

  const trees = () => {
    let one = (totalProduction) * (-0.000689551)
    if (nest > 0) {
      one = (totalProduction - nestAmount) * (-0.000689551)
    }
    let two = -one
    let three = two * 1.10231
    let four = three * 798
    return <span>{Math.round(four).toLocaleString(undefined)}</span>
  }

  // console.log(custUtility)

  const prePayment = () => {
    if (custUtility === 'Oncor' || custUtility === 'TXU' || custUtility === 'Reliant' || custUtility === 'Green Mountain Energy' || custUtility === 'PEC - Pedernales Electric Cooperative' || custUtility === 'GVEC -Guadalupe Valley Electric Cooperative' || custUtility === 'Bluebonnet Electric Cooperative' || custUtility === 'NBU- New Braunfels Utilities' || custUtility === 'City of Boerne Public Utilities' || custUtility === 'CPS - City Public Service' || custUtility === 'Colorado Springs Utilities' || custUtility === 'City of Georgetown Utility' || custUtility === 'Portland General Electric (PGE)' || custUtility === 'Pacific Power') {
      return Math.round(loanA[4] * loanAmount)
    }
    let tax = stateTax;
    if (utilityLocation === 'South Carolina') {
      tax = 3500
    }
    if (stateTax > 0 && loanA[1] === 'DIVIDEND') {

      if (loanA[6] > 0) {
        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 16
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .74 - tax)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - tax)

      return Math.round(g)
    }
    if (stateTax > 0 && loanA[1] === 'SUNLIGHT') {
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - tax)

      return Math.round(g)
    }
    if (stateTax > 0 && loanA[1] === 'MOSAIC') {
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - tax)

      return Math.round(g)
    }
    if (stateTax > 0 && loanA[1] === 'GOODLEAP 22') {
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .78 - tax)

      return Math.round(g)
    }
    if (stateTax > 0 && loanA[1] === 'GOODLEAP') {
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - tax)

      return Math.round(g)
    }
    if (rebate > 0 && loanA[1] === 'DIVIDEND') {

      if (loanA[6] > 0) {
        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 16
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .74 - rebate)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - rebate)

      return Math.round(g)
    }
    if (rebate > 0 && loanA[1] === 'SUNLIGHT') {
      if (custUtility === 'Austin Energy') {

        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 12
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .74 - rebate)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - rebate)

      return Math.round(g)
    }
    if (rebate > 0 && loanA[1] === 'GOODLEAP') {
      if (custUtility === 'Austin Energy') {

        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 12
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .74 - rebate)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - rebate)

      return Math.round(g)
    }
    if (rebate > 0 && loanA[1] === 'DIVIDEND') {
      if (custUtility === 'Salem Electric') {

        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 12
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .74 - rebate)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - rebate)

      return Math.round(g)
    }
    if (rebate > 0 && loanA[1] === 'GOODLEAP 22') {
      if (custUtility === 'Austin Energy') {

        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 12
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .78 - rebate)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .78 - rebate)

      return Math.round(g)
    }
    return Math.round(loanA[4] * loanAmount)


  }
  // console.log(Math.round(loanA[4] * loanAmount), prePayment())
  const monthlyPayments = () => {
    if (loanA[6] > 0) {
      return (loanA[2] * 12) - 16
    } return (loanA[2] * 12) - 18
  }

  const postPayment = () => {
    if (stateTax || custUtility === 'City of Fort Collins Utilities' || custUtility === 'Salem Electric' || (custUtility === 'Austin Energy' && rebate > 0)) {
      return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'baseline' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontSize: '3rem' }}>${Math.round(loanA[4] * loanAmount)}</span>
        </div>
        <div className='font'>
          {loanA[6] > 0 ? (
            <>
              <span className='fontTest' >{monthlyPayments()} MONTHLY PAYMENTS IF ONLY FEDERAL<br /> TAX CREDIT APPLIED TO LOAN:</span>
            </>
          ) : (
            <>
              <span className='fontTest' >{monthlyPayments()} MONTHLY PAYMENTS IF UTILITY REBATE &<br /> FEDERAL TAX CREDIT APPLIED TO LOAN:</span>
            </>
          )}
          <span >${prePayment()}</span>
        </div>
      </div>
    } return <span style={{ fontSize: '3rem' }}>${prePayment()}</span>
  }
  // console.log(stateTax)


  useEffect(() => {
    if (custUtility === 'CPS - City Public Service' || custUtility === 'Colorado Springs Utilities' || custUtility === 'Portland General Electric (PGE)' || custUtility === 'Pacific Power') {
      setRebateSF(rebate)
    }
  }, [rebate, custUtility])


  const [displayProd, setDisplayProd] = useState('')

  useEffect(() => {
    if (nest > 0) {
      return setDisplayProd(Math.round((+totalProduction - +nestAmount)))
    } return setDisplayProd(Math.round(+totalProduction))
  }, [totalProduction, nest])


  let propVersion = props.match.params.number

  // console.log(loanA[6])

  //loan[0] = loanId
  //loan[1] = loanName
  //loan[2] = term
  //loan[3] = interest
  //loan[4] = prePayment
  //loan[5] = postPayment
  //loan[6] = intOnlyPayment

  const [slider, setSlider] = useState(false)

  let netCost = Math.round(+loanAmount + +downPayment - ((+loanAmount + +downPayment - homeEnergyTotal) * loanA[7]) - stateTax)
  if (custUtility === 'City of Fort Collins Utilities' || custUtility === 'Austin Energy') {
    netCost = Math.round(+loanAmount - +rebate + +downPayment - ((+loanAmount + +downPayment - homeEnergyTotal) * loanA[7]) - stateTax)
  }



  return (
    <div className='body' >
      <Title title={`${systemSize / 1000}-${name}-Proposal-v${propVersion}`} />
      <div className='page1c'>
        {name ? (
          <>
            <div className='namec'>
              <span>{name}</span>
              <span>{phone}</span>
              <span>{street}</span>
              <span>{city}, {state} {zip}</span>
            </div>
          </>
        ) : (
          <div className='loading-boxc'>
            <CircularProgress size={50} color="inherit" />
          </div>
        )}
      </div>

      <div className='page2c'>
        <div>
          <div className='twentyFiveYrc'>
            <span>${Math.round((total(years) * 12)).toLocaleString(undefined)}</span>
          </div>
          <div className='barChartc'>
            <BarChart years={years} />
          </div>
          <div className='name2c'>
            <span>${Math.round(billCalc[1])}</span>
            <span>${Math.round(billCalc[3]).toLocaleString(undefined)}</span>
            <span>{increase}%</span>
            <span>${Math.round((total(years) * 12)).toLocaleString(undefined)}</span>
          </div>
        </div>
        <div className='greenCalcsc'>
          <div className='greenCalcs1c'>
            {gallons()}
            {homes()}
            {garbage()}
          </div>
          <div className='greenCalcs2c'>
            {trees()}
          </div>
        </div>
      </div>

      <div className='page3c'>
        <div className='fillerc'>
        </div>
      </div>
      <div className='page4c'>
        <div className='designWrapperc'>
          <div className='originalDesignc'>

            {
              panelAmount > originalPanelAmount ? (
                <>
                  <span> {originalPanelAmount} Panel Design, plus {panelAmount - originalPanelAmount} panel(s) </span>
                  <span>(Original Design Below)</span>
                </>
              ) : panelAmount < originalPanelAmount ? (<>
                <span> {originalPanelAmount} Panel Design, minus {originalPanelAmount - panelAmount} panel(s) </span>
                <span>(Original Design Below)</span>
              </>
              ) : (
                <>
                  <span style={{ marginBottom: '1.3rem' }}>  {originalPanelAmount} Panel Design </span>
                </>
              )
            }

          </div>
          <div className='designc' style={{ backgroundImage: `url(${design})` }}></div>
        </div>
      </div>

      <div className={uType === 'Square Footage' ? 'page5c page5SqFtc' : uType === 'Partial 12 Months' ? 'page5c page5PartialUsagec' : 'page5c'}>
        <div className={uType === 'Square Footage' ? 'systemInfoc systemInfoSqFtc' : uType === 'Partial 12 Months' ? 'systemInfoc systemInfoPartialc' : 'systemInfoc'}>
          <div className={uType === 'Square Footage' ? 'page5Leftc page5LeftSqFtc' : 'page5Leftc'}>
            <div className='left1c'>
              <span>{systemSize / 1000} kW</span>
              {/* <span>{nest ? Math.round((totalProduction - nestAmount)).toLocaleString(undefined) : Math.round(totalProduction).toLocaleString(undefined)} kWh </span> */}
              <span>{displayProd.toLocaleString(undefined)} kWh </span>
            </div>
            <div className={uType === 'Square Footage' ? 'left2c noDisplayc' : 'left2c'}>
              <span className={uType === 'Square Footage' ? ' noDisplayc' : ''}>{nest > 0 ? ((nestAmount / totalUsage)).toLocaleString('en-US', { style: 'percent' }) : '-'}</span>
              {offset()}
              <span className={uType === 'Square Footage' ? ' noDisplayc' : ''}>{Math.round((totalProduction / +totalUsage * 100))}%</span>
            </div>
          </div>
          <div className='nestc' >
            <div className={uType === 'Square Footage' ? 'doughnutChartc noDisplayc' : 'doughnutChartc'}>
              <DoughnutChart
                totalUsage={totalUsage}
                propRatio={propRatio}
                systemSize={systemSize}
                totalProduction={totalProduction}
                nestAmount={nestAmount}
                nest={nest}
              />
            </div>
          </div>
          <div>
            <div className={uType === 'Square Footage' ? 'rightc rightSqFtc' : 'rightc'}>
              <div className={uType === 'Square Footage' ? 'subRightc subRightSqFtc' : 'subRightc'}>
                <div >
                  <span>{panelAmount} {mod[1]} {mod[3]}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  {/* {panelAmount === +maxModCount ? (
                      <ArrowUpwardSharpIcon fontSize="large" color='disabled' />
                    ) : (
                        <ArrowUpwardSharpIcon fontSize="large" onClick={() => addPanel()} />
                      )}
                    {panelAmount === 7 ? (
                      <ArrowDownwardSharpIcon fontSize="large" color='disabled' />
                    ) : (
                        <ArrowDownwardSharpIcon fontSize="large" onClick={() => removePanel()} />
                      )} */}
                </div>
                <div>
                  <span>{invType} IQ</span>
                </div>
              </div>
              <div className={uType === 'Square Footage' ? 'lowRightc lowRightSqFtc' : 'lowRightc'}>
                <span>Enphase Envoy IQ</span>
              </div>
            </div>
            <div className={uType === 'Square Footage' ? 'productionChartc productionChartSqFtc' : 'productionChartc'}>
              <OffsetChart
                uType={uType}
                usage={usage}
                production={production}
                systemSize={systemSize}
                totalProduction={totalProduction}
                nestAmount={nestAmount}
                pRatio={pRatio}
                currentUsage={currentUsage}
              />
            </div>
          </div>
        </div>
      </div>

      <div className='page6c'>
        <div className='page6Loanc'>
          <div className='loanReviewc'>
            <div className='leftPaymentsc'>
              <span >{postPayment()}</span>
              <div className='leftPaymentsBottomc'>
                <div className='font'>
                  <span className='fontTestc'>{monthlyPayments()} MONTHLY PAYMENTS IF INCENTIVE<br />
                    INVESTMENT NOT APPLIED TOWARD LOAN:</span>
                  <span>${Math.round(loanA[5] * loanAmount)}</span>
                </div>
                {
                  loanA[6] > 0 && loanA[1] === 'Dividend' ? (
                    <>
                      <div className='font'>
                        <span className='fontTestc'>MONTHLY PAYMENTS IN MONTHS 1-16<br />
                          PRIOR TO INVESTMENT PAYMENT:</span>
                        <span >${Math.round(loanA[6] * loanAmount)}</span>
                      </div>
                    </>
                  ) : loanA[6] > 0 && loanA[1] === 'Sunlight Int Only' ? (
                    <>
                      <div className='font'>
                        <span className='fontTestc'>MONTHLY PAYMENTS IN MONTHS 1-18<br />
                          PRIOR TO INVESTMENT PAYMENT:</span>
                        <span >${Math.round(loanA[6] * loanAmount)}</span>
                      </div>
                    </>
                  ) : (
                    <>
                    </>
                  )
                }
              </div>
            </div>
            <div className='financeOptionsc'>
              {/* {console.log(rebateSF)} */}
              <div className='discountsc' >
                {sameDay === 1 ? (
                  <>
                    <span className='discountFontc'>Same Day</span>
                  </>
                ) : preferredUtility === 1 ? (
                  <>
                    <span className='discountFontc'>Preferred Utility Discount</span>
                  </>
                ) : referral === 1 ? (
                  <span className='discountFontc'>Referral</span>
                ) : utility === 'Portland General Electric (PGE)' || utility === 'Pacific Power' ? (
                  +rebateSF > 0 ? (
                    <>
                      <span className='discountFontc'>{oregonLabel}</span>
                      {/* <span className='discountFontc'>Energy Trust Incentive</span> */}
                    </>
                  ) : (
                    <>
                      <span className='discountFontc'>Upfront Rebate</span>
                    </>
                  )
                ) : (
                  custUtility === 'Austin Energy' && proposal.rebate > 0 ? <span className='discountFontc'>Utility Rebate</span> : <span className='discountFontc'>Upfront Rebate</span>

                )}
              </div>
              <div className='financeInnerc'>
                <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(systemCost).toLocaleString(undefined)}</span>
                <span>${Math.round(downPayment).toLocaleString(undefined)}</span>
                {/* <span>${Math.round(rebate).toLocaleString(undefined)}</span> */}
                {sameDay === 1 ? (
                  <>
                    <span>${Math.round(sameDayAmount).toLocaleString(undefined)}</span>
                  </>
                ) : preferredUtility === 1 ? (
                  <>
                    <span>${Math.round(preferredUtilityAmount * systemSize).toLocaleString(undefined)}</span>
                  </>
                ) : referral === 1 ? (
                  <>
                    <span>${Math.round(referralAmount).toLocaleString(undefined)}</span>
                  </>
                ) : (
                  <span>${Math.round(rebate).toLocaleString(undefined)}</span>
                )}
                <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loanAmount).toLocaleString(undefined)}</span>
                <span>${Math.round((loanAmount + +downPayment - homeEnergyTotal) * loanA[7]).toLocaleString(undefined)}</span>
                {/* {console.log(loanAmount, downPayment, systemCost)} */}
                <span>${stateTax.toLocaleString(undefined)}</span>
                <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(netCost).toLocaleString(undefined)}</span>
                <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loan1Savings).toLocaleString(undefined)}</span>
                <span>{loanA[2]} years</span>
                <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loanA[4] * loanAmount)}</span>
              </div>
              <div className='financeInnerc'>
                <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(systemCost).toLocaleString(undefined)}</span>
                <span>${Math.round(downPayment).toLocaleString(undefined)}</span>
                {/* <span>${Math.round(rebate).toLocaleString(undefined)}</span> */}
                {sameDay === 1 ? (
                  <>
                    <span>${Math.round(sameDayAmount).toLocaleString(undefined)}</span>
                  </>
                ) : preferredUtility === 1 ? (
                  <>
                    <span>${Math.round(preferredUtilityAmount * systemSize).toLocaleString(undefined)}</span>
                  </>
                ) : referral === 1 ? (
                  <>
                    <span>${Math.round(referralAmount).toLocaleString(undefined)}</span>
                  </>
                ) : (
                  <span>${Math.round(rebate).toLocaleString(undefined)}</span>
                )}
                <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loanAmount).toLocaleString(undefined)}</span>
                <span>${Math.round((loanAmount + +downPayment - homeEnergyTotal) * loanB[7]).toLocaleString(undefined)}</span>
                <span>${stateTax.toLocaleString(undefined)}</span>
                <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(netCost).toLocaleString(undefined)}</span>
                <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loan2Savings).toLocaleString(undefined)}</span>
                <span>{loanB[2]} years</span>
                <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loanB[4] * loanAmount)}</span>
              </div>
            </div>
          </div>
          <div className='loanSummaryc'>
            <div className='loanSummaryLeftc'>
              <div className='loanSummaryLeftTopc'>
                <span>${Math.round(systemCost).toLocaleString(undefined)}</span>
                <div className="loanSummaryLeftRebatec">
                  {/* {utility === 'Portland General Electric (PGE)' || utility === 'Pacific Power' ? (
                      rebateSF ? (
                        <>
                          <span className='fontTestc'>ENERGY TRUST INCENTIVE</span>
                        </>
                      ) : (
                        <span className='fontTestc'>INSTALLER PAID INCENTIVE</span>
                      )
                    ) : (
                        <>
                          <span className='fontTestc'>INSTALLER PAID INCENTIVE</span>
                        </>
                      )} */}
                  {sameDay === 1 ? (
                    <>
                      <span className='fontTestc'>SAME DAY DISCOUNT</span>
                    </>
                  ) : preferredUtility === 1 ? (
                    <>
                      <span className='fontTestc'>PREFERRED UTILITY DISCOUNT</span>
                    </>
                  ) : referral === 1 ? (
                    <span className='fontTestc'>REFERRAL DISCOUNT</span>
                  )
                    : utility === 'Portland General Electric (PGE)' || utility === 'Pacific Power' ? (
                      +rebateSF > 0 ? (
                        <>
                          <span className='fontTestc'>{oregonLabel.toUpperCase()}</span>
                          {/* <span className='fontTestc'>ENERGY TRUST INCENTIVE</span> */}
                        </>
                      ) : (
                        <span className='fontTestc'>INSTALLER PAID INCENTIVE</span>
                      )
                    ) : (
                      custUtility === 'Austin Energy' && proposal.rebate > 0 ? <span className='fontTestc'>UTILITY REBATE</span> : <span className='fontTestc'>INSTALLER PAID INCENTIVE</span>
                    )}
                  {sameDay === 1 ? (
                    <>
                      <span>${Math.round(sameDayAmount).toLocaleString(undefined)}</span>
                    </>
                  ) : preferredUtility === 1 ? (
                    <>
                      <span>${Math.round(preferredUtilityAmount * systemSize).toLocaleString(undefined)}</span>
                    </>
                  ) : referral === 1 ? (
                    <>
                      <span>${Math.round(referralAmount).toLocaleString(undefined)}</span>
                    </>
                  ) : (
                    <span>${Math.round(rebate).toLocaleString(undefined)}</span>
                  )}
                </div>
                <span>${Math.round(downPayment).toLocaleString(undefined)}</span>
              </div>
              <div>
                <span>${Math.round(loanAmount).toLocaleString(undefined)}</span>
              </div>
            </div>
            <div className='loanSummaryRightc'>
              <span>${Math.round((loanAmount + +downPayment - homeEnergyTotal) * loanA[7] + stateTax).toLocaleString(undefined)}</span>
              <span>${Math.round(netCost).toLocaleString(undefined)}</span>
            </div>
            <div className='yearAvgChartc'>
              {
                loanA ? (
                  <YearAvgChart
                    years={years}
                    totalUsage={totalUsage}
                    postYears={postYears}
                    totalProduction={totalProduction}
                    loan1Bills={loan1Bills}
                    loan2Bills={loan2Bills}
                  />
                ) : (
                  <>
                  </>)
              }
            </div>
          </div>
        </div>
        {/* {utility === 'Portland General Electric (PGE)' || utility === 'Pacific Power' ? (
          <div>
            <span className='discountFontc' style={{ marginLeft: '13rem' }}>*Cannot combine with Energy Trust.</span>
          </div>
        ) : (
            <>
            </>
          )} */}
      </div>

      <div className={+loan1Savings < 0 && custUtility === 'Austin Energy' ? 'noDisplay' : 'page7c'}>
        <div className="savingsReportc">
          <div className='savingsOptionsc'>
            <div className='optionNamec'>
              <span>{loanA[1]} {loanA[2]} YEAR {loanA[3]}% APR</span>
              {/* <Button variant="contained" onClick={handleClick1} aria-controls="simple-menu" aria-haspopup="true" style={{ display: 'flex', width: '100%', height: '47px' }}>
                  <span style={{ fontSize: '1.6rem' }}>{loanA[1]} {loanA[2]} year {loanA[3]}</span>
                </Button>
                <Menu
                  // onChange={e => setLoanA(e.target.value)}
                  id="long-menu"
                  anchorEl={anchorLoan1}
                  keepMounted
                  open={Boolean(anchorLoan1)}
                  onClose={handleClose1}
                // labelWidth={labelWidth}
                >
                  <MappedLoans1
                    handleClose1={handleClose1}
                    setLoanA={setLoanA}
                    utilityLocation={utilityLocation}
                  />
                </Menu> */}
            </div>
            <div className='optionTermsc'>
              <span >${Math.round(loanA[4] * loanAmount)}</span>
              <span>{loanA[2]} years</span>
              <span>${Math.round(loan1Savings).toLocaleString(undefined)}</span>
            </div>
            <div className='postPaymentc'>
              <span>${Math.round(loanA[5] * loanAmount)}</span>
            </div>
            <div className='option25c'>
              <span>${Math.round(total(years) * 12).toLocaleString(undefined)}</span>
              {
                loanA ? (
                  <span>${Math.round(total(loan1Bills) * 12).toLocaleString(undefined)}</span>
                ) : (
                  <>
                  </>)
              }
              {
                total(postYears) * 12 <= 0 ? (
                  <span>${Math.round(total(postYears1)).toLocaleString(undefined)}</span>
                ) : (

                  <span>${Math.round(total(postYears) * 12).toLocaleString(undefined)}</span>
                )
              }
            </div>
            <div className='totalSavingsc'>
              <span>${Math.round(loan1Savings).toLocaleString(undefined)}</span>
            </div>
          </div>
          <div className='savingsOptionsc'>
            <div className='optionNamec'>
              <span>{loanB[1]} {loanB[2]} YEAR {loanB[3]}% APR</span>
              {/* <Button variant="contained" onClick={handleClick2} aria-controls="simple-menu" aria-haspopup="true" style={{ display: 'flex', width: '100%', height: '47px' }}>
                  <span style={{ fontSize: '1.6rem' }}>{loanB[1]} {loanB[2]} year {loanB[3]}</span>
                </Button>
                <Menu
                  // onChange={e => setLoanB(e.target.value)}
                  id="long-menu"
                  anchorEl={anchorLoan2}
                  keepMounted
                  open={Boolean(anchorLoan2)}
                  onClose={handleClose2}
                // labelWidth={labelWidth}
                >
                  <MappedLoans2
                    handleClose2={handleClose2}
                    setLoanB={setLoanB}
                    utilityLocation={utilityLocation}
                  />
                </Menu> */}
            </div>
            <div className='optionTermsc'>
              <span >${Math.round(loanB[4] * loanAmount)}</span>
              <span>{loanB[2]} years</span>
              <span>${Math.round(loan2Savings).toLocaleString(undefined)}</span>
            </div>
            <div className='postPaymentc'>
              <span>${Math.round(loanB[5] * loanAmount)}</span>
            </div>
            <div className='option25c'>
              <span>${Math.round(total(years) * 12).toLocaleString(undefined)}</span>
              <span>${Math.round(total(loan2Bills) * 12).toLocaleString(undefined)}</span>
              {
                total(postYears) * 12 <= 0 ? (
                  <span>${Math.round(total(postYears1)).toLocaleString(undefined)}</span>
                ) : (

                  <span>${Math.round(total(postYears) * 12).toLocaleString(undefined)}</span>
                )
              }
            </div>
            <div className='totalSavingsc'>
              <span>${Math.round(loan2Savings).toLocaleString(undefined)}</span>
            </div>
          </div>
        </div>
      </div>

      <div className={custUtility === 'Austin Energy' ? 'page8Austinc' : 'page8c'}>
        <div>
          <div className='utilityc'>
            <span>{utility}</span>
            <span>${Math.round(billCalc[1])}</span>
            <span>${(billCalc[1] / billCalc[4]).toFixed(3)}</span>
            <span>{increase}%</span>
          </div>
          <div className='systemc'>
            <span>{systemSize / 1000} kW</span>
            <span>{nest > 0 ? Math.round((totalProduction - nestAmount)).toLocaleString(undefined) : Math.round(totalProduction).toLocaleString(undefined)}</span>
            <span>0.5%</span>
          </div>
          <div className='loanc'>
            <span>${Math.round(systemCost).toLocaleString(undefined)}</span>
            <span>${Math.round(rebate).toLocaleString(undefined)}</span>
            <span>${Math.round(downPayment).toLocaleString(undefined)}</span>
          </div>
          <div className='optionsc'>
            <div className='optionc'>
              <span>Option 1</span>
              <span>{loanA[3]}%</span>
              <span>{loanA[2]} years</span>
              <span>${Math.round((systemCost - rebate - homeEnergyTotal) * loanA[7]).toLocaleString(undefined)}</span>
            </div>
            <div className='optionc'>
              <span>Option 2</span>
              <span>{loanB[3]}%</span>
              <span>{loanB[2]} years</span>
              <span>${Math.round((systemCost - rebate - homeEnergyTotal) * loanB[7]).toLocaleString(undefined)}</span>
            </div>
          </div>
        </div>
        <div className="bottomRebatec">
          {utility === 'Portland General Electric (PGE)' || utility === 'Pacific Power' ? (
            +rebateSF > 0 ? (
              <>
                <span className='optionRebatec'>{oregonLabel}</span>
                {/* <span className='optionRebatec'>Energy Trust Incentive</span> */}
              </>
            ) : (
              <>
                <span className='optionRebatec'>Installer Paid Incentive</span>
              </>
            )
          ) : (
            <>
              {custUtility === 'Austin Energy' && proposal.rebate > 0 ? <span className="optionRebatec">Utility Rebate</span> : <span className="optionRebatec">Installer Paid Incentive</span>}
            </>
          )}
        </div>
      </div>
      {+proposal.battery10 > 0 ? (
        <>
          <div className='page9c'>
            {/* <div className='fillerc'>
            </div> */}
          </div>
        </>
      ) : (
        <>
        </>
      )}
    </div >
  )
}
export default ProposalView